import { UserActivityEvent } from '../../enums/UserActivity';
import EventsInterface from '../../graphql/Events/EventsInterface';
import UserStore from '../../stores/observables/UserStore';

interface ContentRelatedActivity {
  contentId: string;
  version?: number;
}

interface RoomRelatedActivity {
  roomId: string;
}

export type ActivityTrackerMetadata =
  | ContentRelatedActivity
  | RoomRelatedActivity;

export default class ActivityTracker {
  public static track(event: UserActivityEvent, meta: ActivityTrackerMetadata) {
    const isAuthenticatedUser = !!UserStore.get();
    if (isAuthenticatedUser) {
      try {
        new EventsInterface().create({ event, meta });
      } catch (e) {
        // do nothing, as this isn't something of interest for users
      }
    }
  }
}
